import React, { useState, useEffect, useRef } from "react";
import { StyledBackgroundImage } from "./StyledBgImage";
import { GetBackgroundPositionCoordinates } from "../helpers/ImageHelper/ImageHelper";

const BackgroundImage = ({ source, onLoad, children, useFocalPoint, ...imageProps }) => {
	const [imgSrc, setImageSrc] = useState("");
	const [isCropped, setIsCropped] = useState(false);
	const [coordinates, setCoordinates] = useState({});
	const refBgImage = useRef();

	useEffect(() => {
		const img = new Image();
		img.src = source;
		img.onload = () => {
			setImageSrc(source);
		};
		const bgPositionCoordinats = GetBackgroundPositionCoordinates(source);
		const { mode } = bgPositionCoordinats;
		setCoordinates(bgPositionCoordinats);
		setIsCropped(mode !== undefined && mode.length);
	}, []);
	return (
		<StyledBackgroundImage
			ref={refBgImage}
			{...imageProps}
			fadeIn={onLoad}
			bgImage={imgSrc}
			isCropped={isCropped}
			coordinates={useFocalPoint != undefined && coordinates}
		>
			{children != undefined && children}
		</StyledBackgroundImage>
	);
};

export default BackgroundImage;
